// extracted by mini-css-extract-plugin
export var cancelButton = "_pa-5";
export var content = "_pa-3";
export var createButton = "_pa-6";
export var drawerContainer = "_pa-0";
export var footer = "_pa-2";
export var header = "_pa-1";
export var orderFormColumn = "_pa-4";